import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import FormikCheckbox from '../../../../base/forms/formikCheckbox';
import FormikFieldWrapper from '../../../../base/forms/formikFieldWrapper';
import FormikSelect from '../../../../base/forms/formikSelect';
import { StyledFormikField } from '../../../../base/forms/input';
import { Column, Columns } from '../../../../base/grid';
import { IStepInfo } from '../../stepInfo.schema';

interface Props {
	values: IStepInfo;
	setFieldTouched: any;
	setFieldValue: any;
	postcodes: any;
	countries: any;
}

const showOrHideStar = values => {
	const { whoFillsOut } = values;
	const result = whoFillsOut === 'recipient' ? '*' : '';
	return result;
};

const ReceiverFields: FC<Props> = ({ values, setFieldTouched, setFieldValue, postcodes, countries }) => {
	const { t } = useTranslation(['registerShipment', 'generalForm', 'damageReport']);
	return (
		<Columns>
			<Column>
				<FormikCheckbox
					name="receiverIsForeign"
					id="receiverIsForeign"
					label={t('damageReport:receiver-foreign-address')}
					setFieldValue={setFieldValue}
				/>
			</Column>
			<Column tablet={1 / 2}>
				<FormikFieldWrapper
					label={`${t('step-info.name')} *`}
					name="receiverName"
					languageComponent="registerShipment"
					smallLabel>
					<StyledFormikField
						type="text"
						id="receiverName"
						name="receiverName"
						placeholder={t('step-info.name')}
						autoComplete="name"
					/>
				</FormikFieldWrapper>
			</Column>
			<Column tablet={1 / 2}>
				<FormikFieldWrapper
					label={t('step-info.ssn')}
					name="receiverSsn"
					languageComponent="registerShipment"
					smallLabel>
					<StyledFormikField
						type="text"
						id="receiverSsn"
						name="receiverSsn"
						placeholder={t('step-info.ssn')}
					/>
				</FormikFieldWrapper>
			</Column>
			<Column tablet={1 / 2}>
				<FormikFieldWrapper
					label={`${t('step-info.address')} *`}
					name="receiverAddress"
					languageComponent="registerShipment"
					smallLabel>
					<StyledFormikField
						type="text"
						id="receiverAddress"
						name="receiverAddress"
						placeholder={t('step-info.address')}
						autoComplete="address"
					/>
				</FormikFieldWrapper>
			</Column>
			{!values.receiverIsForeign && (
				<Column tablet={1 / 2}>
					<FormikFieldWrapper
						label={`${t('step-info.postcode')} *`}
						name="receiverZip"
						languageComponent="registerShipment"
						smallLabel>
						<FormikSelect
							id="receiverZip"
							name="receiverZip"
							options={postcodes}
							value={values.receiverZip}
							placeholder={t('step-info.postcode')}
							onBlur={setFieldTouched}
							onChange={setFieldValue}
						/>
					</FormikFieldWrapper>
				</Column>
			)}

			{values.receiverIsForeign && (
				<>
					<Column tablet={1 / 2}>
						<FormikFieldWrapper
							label={`${t('step-info.postcode')} *`}
							name="receiverForeignZip"
							languageComponent="registerShipment"
							smallLabel>
							<StyledFormikField
								type="text"
								id="receiverForeignZip"
								name="receiverForeignZip"
								placeholder={t('step-info.postcode')}
								autoComplete="postal code"
							/>
						</FormikFieldWrapper>
					</Column>

					<Column tablet={1 / 2}>
						<FormikFieldWrapper
							label={`${t('generalForm:city')} *`}
							name="receiverForeignCity"
							languageComponent="registerShipment"
							smallLabel>
							<StyledFormikField
								type="text"
								id="receiverForeignCity"
								name="receiverForeignCity"
								placeholder={t('generalForm:city')}
								autoComplete="city"
							/>
						</FormikFieldWrapper>
					</Column>

					<Column tablet={1 / 2}>
						<FormikFieldWrapper
							label={`${t('generalForm:chooseCountry')} *`}
							smallLabel
							name="receiverForeignCountry"
							languageComponent="registerShipment">
							<FormikSelect
								id="receiverForeignCountry"
								name="receiverForeignCountry"
								value={values.receiverForeignCountry}
								options={countries}
								onBlur={setFieldTouched}
								onChange={setFieldValue}
								placeholder={t('generalForm:chooseCountry')}
							/>
						</FormikFieldWrapper>
					</Column>
				</>
			)}

			<Column tablet={1 / 2}>
				<FormikFieldWrapper
					label={`${t('step-info.email')}${showOrHideStar(values)}`}
					name="receiverEmail"
					languageComponent="registerShipment"
					smallLabel>
					<StyledFormikField
						type="text"
						id="receiverEmail"
						name="receiverEmail"
						placeholder={`${t('step-info.email')}${showOrHideStar(values)}`}
						autoComplete="email"
					/>
				</FormikFieldWrapper>
			</Column>
			<Column tablet={1 / 2}>
				<FormikFieldWrapper
					label={t('step-info.phone')}
					name="receiverPhone"
					languageComponent="registerShipment"
					smallLabel>
					<StyledFormikField
						type="number"
						id="receiverPhone"
						name="receiverPhone"
						placeholder={t('step-info.phone')}
						autoComplete="phone"
						onWheel={e => e.currentTarget.blur()} // Prevents s
					/>
				</FormikFieldWrapper>
			</Column>
			<Column tablet={values.receiverIsForeign ? 1 / 2 : 1}>
				<FormikFieldWrapper
					label={t('step-info.contact')}
					name="receiverContact"
					languageComponent="registerShipment"
					smallLabel>
					<StyledFormikField
						type="text"
						id="receiverContact"
						name="receiverContact"
						placeholder={t('step-info.contact')}
					/>
				</FormikFieldWrapper>
			</Column>
		</Columns>
	);
};

export default ReceiverFields;
